import FilePreview from './components/PreviewFile/index.vue'

// 导出组件
export default FilePreview

// 导出为Vue插件
export const Vue2PdfPreview = {
  install(Vue) {
    Vue.component('FilePreview', FilePreview)
  }
}

// 自动安装
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Vue2PdfPreview)
} 